import Grid from '@blocks/Grid'
import { ReactComponent as TrophyIcon } from '@icons/trophy.svg'
import { colors } from '@styles/vars'
import React from 'react'
import styled from 'styled-components'
import DownloadAwardCertificate from './components/DownloadAwardCertificate'

export default function PastParticipationAward({ award }: Props) {
    if (!award)
        return null

    return (
        <Grid gap="10px">
            <DownloadAwardWrapper>
                <IconWrapper><TrophyIcon /></IconWrapper>{award}
            </DownloadAwardWrapper>
            <DownloadAwardCertificate />
        </Grid>
    )
}

// STYLES
const DownloadAwardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.black};
    color: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 24px;
    width: 100%;
    padding: 7px 10px;
    font-weight: 600;
    height: 48px;

    a {
        display: flex;
        align-items: center;
        text-decoration: none;
        font-weight: 600;
    }
    
    svg {
        fill: ${colors.white};
    }
`

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 5px;

    svg {
        fill: ${colors.white};
        width: 24px;
        height: 24px;
    }
`

interface Props {
    award: string | null
}